import { IonIcon, IonRouterLink } from '@ionic/react'
import { chevronForwardOutline } from 'ionicons/icons'
import { observer } from 'mobx-react'
import styled from 'styled-components'
import { TextStyle } from '../../../components'

type Props = {
  href?: string
  style?: React.CSSProperties
  title: string
  subTitle?: string
  icon?: string
  onClick?: () => void
}

export const SubTitle: React.FC<Props> = observer(({ title, subTitle, href, style, icon, onClick }) => {
  return (
    <IonRouterLink routerLink={href} onClick={onClick}>
      <SectionTitleWrap style={{ ...style }}>
        <MainTitleWrap>
          {icon && <IonIcon color={'dark'} icon={icon} />}
          <TextStyle type={'m_15'} color={'primary_main'}>
            {title}
          </TextStyle>
        </MainTitleWrap>
        <SubTitleWrap>
          <p>{subTitle}</p>
          <IonIcon color={'medium'} icon={chevronForwardOutline} />
        </SubTitleWrap>
      </SectionTitleWrap>
    </IonRouterLink>
  )
})

const SectionTitleWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 20px;
  height: 50px;
  :hover {
    background-color: var(--ion-color-gray100);
  }
`

const MainTitleWrap = styled.div`
  display: flex;
  align-items: center;
  ion-icon {
    margin-right: 10px;
  }
`

const SubTitleWrap = styled.div`
  display: flex;
  align-items: center;
  p {
    margin: 0 0 2px 0;
    font-size: 15px;
  }
`
